import { createAction } from "redux-act";
import { createRoutine } from "../utils/routine.utils";
export var openSocket = createRoutine("SOCKET_OPEN");
export var closeSocket = createRoutine("SOCKET_CLOSE");
export var socketMessageReceived = createAction("SOCKET_MESSAGE_RECEIVED");
export var socketMessageStartPending = createAction("SOCKET_MESSAGE_PENDING_START");
export var socketMessageStopPending = createAction("SOCKET_MESSAGE_PENDING_STOP");
export var socketMessageSend = createAction("SOCKET_MESSAGE_SEND");
export var socketUpdateReadyState = createAction("SOCKET_UPDATE_READY_STATE");
